import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';
import { adaptItemToRequest } from './adapters/adaptItemToRequest';
import { IItem } from './models/IItem';

interface IViewItemListEvent {
	items: IItem[];
}

/**
 * https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#measure_product_impressions
 */
export function trackViewItemList({ items }: IViewItemListEvent) {
	trackWithGoogleAnalytics('event', 'view_item_list', {
		items: items.map(adaptItemToRequest),
	});
}
